const tooltips = {
  szemelyitorzs: 'A funkció célja, hogy lehetőség legyen a felhasználónak arra, hogy a dolgozóit nyilvántartsa a rendszerben. Csak azok a helyszínek láthatóak a felhasználó számára, amelyeknek a szerepköre a felhasználóhoz van rendelve.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
